import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CharacterStoreModel } from '../character-store/character-store';
import { BookmarksStoreModel } from '../kia-request-store/bookmarks-store';
import { ExploreStoreModel } from '../kia-request-store/explore-store';
import { HomeStoreModel } from '../kia-request-store/home-store';
import { KiaRequestStoreModel } from "../kia-request-store/kia-request-store"
import { SearchStoreModel } from '../kia-request-store/search-store';
import { RequestDetailsStoreModel } from '../request-details-store/request-details-store';
import { CreateRequestStoreModel } from '../create-request-store/create-request-store';
/**
 * A RootStore model.
 */
// prettier-ignore
export const RootStoreModel = types.model("RootStore").props({
  characterStore: types.optional(CharacterStoreModel, {} as any),
  requestStore: types.optional(KiaRequestStoreModel, {} as any),
  detailsStore: types.optional(RequestDetailsStoreModel, {} as any),
  exploreStore: types.optional(ExploreStoreModel, {} as any),
  homeStore: types.optional(HomeStoreModel, {} as any),
  bookmarksStore: types.optional(BookmarksStoreModel, {} as any),
  searchStore: types.optional(SearchStoreModel, {} as any),
  createStore: types.optional(CreateRequestStoreModel, {} as any)
})

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
